import { setRoot } from "../render";

export function renderStepDone(info: { date: string; time: string; method: "zoom" | "line_call" }) {
  const [, m, d] = info.date.split("-").map(Number);
  setRoot(`
    <div class="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <div class="text-5xl mb-4">✅</div>
      <h1 class="text-xl font-bold brand">予約完了！</h1>
      <p class="mt-3 text-gray-700">ありがとうございます😊</p>

      <div class="mt-6 bg-gray-50 rounded p-4 text-sm leading-7 inline-block">
        <div>📅 ${m}/${d} ${info.time}〜</div>
        <div>📹 ${info.method === "zoom" ? "オンライン面談（30分）" : "LINE電話（30分）"}</div>
      </div>

      <p class="mt-6 text-gray-600 text-sm">
        LINEに確認メッセージを送りました。<br/>
        ${info.method === "zoom"
          ? "Google Meet 参加リンクはメッセージ内をご確認ください。"
          : "当日のご連絡をお待ちしております。"}
      </p>

      <button id="close-btn" type="button" class="mt-8 bg-brand text-white px-8 py-3 rounded font-bold">
        LINEに戻る
      </button>
    </div>
  `);

  document.getElementById("close-btn")!.addEventListener("click", function (this: HTMLButtonElement) {
    this.disabled = true;
    this.textContent = "閉じています...";
    const liff = (window as any).liff;
    if (!liff) return;
    try {
      if (typeof liff.isInClient === "function" && liff.isInClient()) {
        liff.closeWindow();
      } else if (typeof liff.closeWindow === "function") {
        liff.closeWindow();
      }
    } catch (e) {
      console.error("liff close failed", e);
      this.disabled = false;
      this.textContent = "LINEに戻る";
    }
  });
}
